import * as React from 'react'
import { SelectCl } from "../../../components/select-cl"
import { useEffect, useCallback, useRef, useState } from "react"
import { fetchCcbs } from "./service"
import { fetchCountries } from "../../../domains/ccb/country/service"
import { fetchCities } from "../../../domains/ccb/city/service"
import { fetchCashCorrespondents } from "../../../domains/ccb/cashcorrespondent/service"
import { fetchCurrencies, fetchCurrencyNames } from "../../../domains/ccb/currency/service"
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../../../components/app/reducer'
import Disclaimer from "../../../components/disclaimer"
import { useHistory } from "react-router"

const CcbCriteria: React.FC = () => {

    const rootDispatch = useDispatch();
    const rootDispatchHistory = useDispatch();
    const allDomainsLoaded = useSelector((state: RootReducer) => { return state.ccbCriteriaReducer.allDomainsLoaded });
    const countries = useSelector((state: RootReducer) => state.ccbCriteriaReducer.countries);
    const currencies = useSelector((state: RootReducer) => state.ccbCriteriaReducer.currencies);
    const currenciesShort = useSelector((state: RootReducer) => state.ccbCriteriaReducer.currenciesShort);
    const cities = useSelector((state: RootReducer) => state.ccbCriteriaReducer.cities);
    const cashCorrespondents = useSelector((state: RootReducer) => state.ccbCriteriaReducer.cashCorrespondents);
    const disclaimerAccepted = useSelector((state: RootReducer) => { return state.appReducer.blnAppDisclaimerAgreed });
    const ccbSearchDone = useSelector((state: RootReducer) => state.ccbReducer.searchDone);
    const criteriaOrSearchError = useSelector((state: RootReducer) => {return state.ccbReducer.error || state.ccbCriteriaReducer.error});
    const history = useHistory();
    const [reset, setReset] = useState(0);
    const[disableButton, setDisableButton] = useState(false);
    const[displayLoading, setDisplayLoading] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect( () => {                
        if (criteriaOrSearchError){
            setDisableButton(false);
            setDisplayLoading(false);
        } 
    })

    useEffect(() => {
        if (!allDomainsLoaded && disclaimerAccepted && ! displayLoading) {
            fetchCountries(rootDispatch, "CcbCriteria")
            fetchCities(rootDispatch, "CcbCriteria")
            fetchCashCorrespondents(rootDispatch, "CcbCriteria")
            fetchCurrencies(rootDispatch, "CcbCriteria")
            fetchCurrencyNames(rootDispatch, "CcbCriteria")
        } else {
            //console.log("In CCB Criteria -> All domains loaded")
        }
        // this would re-render
        //  setTimeout(() => {
        //      setState({type:"CcbCriteria/LOADINGFINISHED"})
        //  }, 4000);
        // return is for doing cleanup - does not re-render
        return () => {
            // does not re-render here!!!!!!!
            // setTimeout(() => {
            //     setState({type:"CcbCriteria/LOADINGFINISHED"})
            // }, 4000);

        }
    }       
        , [allDomainsLoaded, rootDispatch, displayLoading, disclaimerAccepted])


    useEffect(() => {
        if (ccbSearchDone) {
            // push new history item == redirect to results page while maintaining the back button function
            history.push("/ccbresults")
        }
        // clean-up immediately as without resetting the searchDone the nex render would be adding another history item
        return (() => { rootDispatch({ type: "CCB/RESETSEARCH" }) })
    }, [ccbSearchDone, history, rootDispatch])
    

    /**
     * reset all the fields
     */
    const onCcbReset = useCallback(() => {
        /*
        ["ccbCurrency", "ccbCurrencyName", "ccbCity", "ccbCtry", "ccbName"].forEach((id) => {
            let inp = document.getElementById(id);
            if (inp) {
                let htmlInp: any = inp;
                htmlInp.value = "---";
            }
        });
        */
        rootDispatch({ type: "CCB/FETCHERROR", payload: ""})
        setReset(reset + 1);
    }, [reset]);

    // const dispatchDisclaimer = useDispatch()
    const formRef = useRef(null)
    //const onSubmitHandle = useCallback(() => true ,[])

    const onSubmitHandle = useCallback(() => {
        if (formRef.current !== null) {
            const elmForm = formRef.current as unknown as HTMLFormElement;
            const data = new FormData(elmForm);
            setDisplayLoading(true);
            setDisableButton(true);
            fetchCcbs(rootDispatch, rootDispatchHistory, data, window.history.state);
        }
        return false;
    }, [rootDispatch, rootDispatchHistory])

    return (
        <div>
            <Disclaimer />
            { disclaimerAccepted && (! allDomainsLoaded  || displayLoading ) &&  ( <> <span>LOADING...</span>   </>) }
            { disclaimerAccepted && criteriaOrSearchError && ( 
                <div> 
                    <ul >
                        <li className="codelist-header bold">{criteriaOrSearchError}</li>
                    </ul>
                </div>) 
            }
            { (! displayLoading && disclaimerAccepted && allDomainsLoaded ) && (
                <form ref={formRef} onSubmit={(e) => {
                    e.preventDefault(); //onSubmitHandle(e)   
                }}>
                    <p className="codelist-header">Cash Correspondents Database</p>

                    <div className="search-header-info">
                        <p>Please enter your search criteria in the fields below.</p>
                        <p>
                            <span className="bold">Download facilities are available on the next pages.</span>
                        </p>
                    </div>

                    <div className="search-control">

                        <span><button disabled = {disableButton} onClick={onSubmitHandle}>Search</button></span>
                        <span><button disabled = {disableButton} onClick={onCcbReset}>Reset</button></span>

                    </div>

                    {(

                        <div className="search-table">
                            <SelectCl
                                id="ccbCurrency"
                                label="Currency (ISO) : "
                                name="curr"
                                options={currencies}
                                reset={reset} />
                            <SelectCl
                                id="ccbCurrencyName"
                                label="Currency Name : "
                                name="currnm"
                                options={currenciesShort} 
                                reset={reset} />
                            <SelectCl
                                id="ccbCity"
                                label="Cash Correspondent City : "
                                name="city"
                                options={cities} 
                                reset={reset} />
                            <SelectCl
                                id="ccbCtry"
                                label="Cash Correspondent Country : "
                                name="ctry"
                                options={countries}
                                reset={reset} />
                            <SelectCl
                                id="ccbName"
                                label="Cash Correspondent : "
                                name="name"
                                options={cashCorrespondents}
                                reset={reset} />
                        </div>
                    )}
                </form>
            )}

        </div>


    )
}

export default CcbCriteria